import React from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

const rules = [
  { label: "At least 8 characters", test: (pw) => pw.length >= 8 },
  { label: "One uppercase letter (A-Z)", test: (pw) => /[A-Z]/.test(pw) },
  { label: "One lowercase letter (a-z)", test: (pw) => /[a-z]/.test(pw) },
  { label: "One number (0-9)", test: (pw) => /[0-9]/.test(pw) },
  {
    label: "One special character (!@#$...)",
    test: (pw) => /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/.test(pw),
  },
];

const PasswordRulesChecklist = ({ password = "" }) => {
  if (!password) return null;

  const passedCount = rules.filter((r) => r.test(password)).length;
  const allPassed = passedCount === rules.length;

  return (
    <Box
      sx={{
        width: "100%",
        mt: 1,
        mb: 1,
        p: 1.5,
        borderRadius: 2,
        bgcolor: allPassed ? "rgba(46,125,50,0.06)" : "rgba(0,0,0,0.03)",
        border: "1px solid",
        borderColor: allPassed ? "rgba(46,125,50,0.2)" : "rgba(0,0,0,0.08)",
        transition: "all 0.3s ease",
      }}
    >
      <Typography
        variant="caption"
        sx={{ fontWeight: 600, color: "#555", mb: 0.5, display: "block" }}
      >
        Password requirements
      </Typography>
      {rules.map((rule, i) => {
        const passed = rule.test(password);
        return (
          <Box
            key={i}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.8,
              py: 0.2,
              transition: "all 0.2s ease",
            }}
          >
            {passed ? (
              <CheckCircleIcon sx={{ fontSize: 16, color: "#2e7d32" }} />
            ) : (
              <RadioButtonUncheckedIcon
                sx={{ fontSize: 16, color: "#bbb" }}
              />
            )}
            <Typography
              variant="caption"
              sx={{
                color: passed ? "#2e7d32" : "#888",
                fontWeight: passed ? 500 : 400,
                textDecoration: passed ? "none" : "none",
              }}
            >
              {rule.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default PasswordRulesChecklist;
